// Set and Get the UserInfo related data from session storage

export const setUserInfo = (data: Record<string, any>) => {
  sessionStorage.setItem('userInfo', JSON.stringify(data));
};

export const getUserInfoSessionData = () => {
  try {
    const data = JSON.parse(sessionStorage.getItem('userInfo'));
    const { externalId = '', email = '' } = data || {};
    if (externalId || email) {
      return data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

export function setIsLoggedInCookie(value: boolean) {
  const cookieValue = value ? 'true' : 'false';
  document.cookie = `isLoggedin=${cookieValue}; path=/; Secure; SameSite=Strict`;
}

export function getIsLoggedInCookie(): string | null {
  const cookies = document.cookie;
  const cookieArray = cookies.split('; ');
  for (const cookie of cookieArray) {
    const [key, value] = cookie.split('=');
    if (key === 'isLoggedin') {
      return value;
    }
  }

  return null;
}



// WEBPACK FOOTER //
// ./utils/sessionUtil.ts